<template>
  <div v-if="visible" id="tabVesselEq" class="tab-vessel-eq">
    <div style="width: fit-content">
      <div style="display: flex">
        <div class="section form-column">
          <el-form :disabled="readonly || hasMaster" label-width="85px" label-position="right">
            <div>
              <span class="title">{{ $t('SeaExport.BookingInfo') }}</span>
              <el-form-item :label="$t('CargoMsg.Cargo_VehicleModel')">
                <cargo-advance-select
                  :method-params="{typeKh:true}"
                  no="vehicleType"
                  :show-custom-label-in-option="true"
                  :custom-label="vehicleTypeLabel"
                  :select-type="selectTypeNames.basic_data_VehicleModel"
                  filterable
                  :clearable="false"
                  :default-value="form.vehicleType"
                  @parentCallBack="p=>{form.vehicleType=p.value;}"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.PlateNumber')">
                <el-input v-model="form.plateNumber" no="plateNumber" :maxlength="10" />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_trailerNumber')">
                <el-input v-model="form.trailerNumber" no="trailerNumber" :maxlength="10" />
              </el-form-item>
              <el-form-item :label="'CMR' + $t('SeaExport.NO')">
                <el-input v-model="form.mbl" no="mbl" />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.Remarks')">
                <el-input
                  v-model="form.remarks"
                  no="remarks"
                  :maxlength="300"
                  type="textarea"
                  :rows="5"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),form.remarks,val=>{form.remarks=val})"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="section form-column" style="width: 430px">
          <el-form :disabled="readonly" label-width="120px" label-position="right">
            <!-- 起运地提卸货信息-->
            <span class="title">{{ $t('CargoMsg.Cargo_polExchangeInfo') }}</span>
            <!-- 拖车提货 -->
            <el-form-item :label="$t('CargoMsg.Cargo_trailerLoad')">
              <!-- 拖车预计提货时间 -->
              <el-date-picker
                v-model="form.estTakeTime"
                no="estTakeTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
                @change="changeTakeTime(false)"
              />
              <!-- 拖车实际提货时间 -->
              <el-date-picker
                v-model="form.actTakeTime"
                no="actTakeTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
                @change="changeTakeTime(true)"
              />
            </el-form-item>
            <!-- 拖车到货 -->
            <el-form-item :label="$t('CargoMsg.Cargo_trailerArrive')">
              <!-- 拖车预计到货时间 -->
              <el-date-picker
                v-model="form.estArriveTime"
                no="estArriveTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
                @change="changeArriveTime(false)"
              />
              <!-- 拖车实际到货时间 -->
              <el-date-picker
                v-model="form.actArriveTime"
                no="actArriveTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
                @change="changeArriveTime(true)"
              />
            </el-form-item>
            <!-- 拖车卸货 -->
            <el-form-item :label="$t('CargoMsg.Cargo_trailerUnload')">
              <!-- 拖车预计卸货时间 -->
              <el-date-picker
                v-model="form.estUnloadTime"
                no="estUnloadTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 拖车实际卸货时间 -->
              <el-date-picker
                v-model="form.actUnloadTime"
                no="actUnloadTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
            <!-- 起运地口岸信息-->
            <span class="title" style="margin-top: 10px; margin-bottom: 10px;">{{ $t('CargoMsg.Cargo_polPortInfo') }}</span>
            <!-- 卡航抵岸 -->
            <el-form-item :label="$t('CargoMsg.Cargo_khLandingTime')">
              <!-- 卡航预计抵岸时间 -->
              <el-date-picker
                v-model="form.estLandingTime"
                no="estLandingTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 卡航实际抵岸时间 -->
              <el-date-picker
                v-model="form.actLandingTime"
                no="actLandingTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
            <!-- 卡航入境 -->
            <el-form-item :label="$t('CargoMsg.Cargo_khEntryTime')">
              <!-- 卡航预计入境时间 -->
              <el-date-picker
                v-model="form.estEntryTime"
                no="estEntryTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 卡航实际入境时间 -->
              <el-date-picker
                v-model="form.actEntryTime"
                no="actEntryTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
            <!-- 卡航换装 -->
            <el-form-item :label="$t('CargoMsg.Cargo_khReplacementTime')">
              <!-- 卡航预计换装时间 -->
              <el-date-picker
                v-model="form.estReplacementTime"
                no="estReplacementTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
                @change="changeReplacementTime(false)"
              />
              <!-- 卡航实际换装时间 -->
              <el-date-picker
                v-model="form.actReplacementTime"
                no="actReplacementTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
                @change="changeReplacementTime(true)"
              />
            </el-form-item>
            <!-- 卡航报关 -->
            <el-form-item :label="$t('CargoMsg.Cargo_khDeclare')">
              <!-- 卡航预计报关时间 -->
              <el-date-picker
                v-model="form.estDeclareTime"
                no="estDeclareTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 卡航实际报关时间 -->
              <el-date-picker
                v-model="form.declareTime"
                no="declareTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
            <!-- 卡航出境 -->
            <el-form-item :label="$t('CargoMsg.Cargo_khExitTime')">
              <!-- 卡航预计出境时间 -->
              <el-date-picker
                v-model="form.estExitTime"
                no="estExitTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 卡航实际出境时间 -->
              <el-date-picker
                v-model="form.actExitTime"
                no="actExitTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
            <!-- 中转地转关信息-->
            <span class="title" style="margin-top: 10px; margin-bottom: 10px;">{{ $t('CargoMsg.Cargo_transferTransitInfo') }}</span>
            <!-- 中转地申报完成 -->
            <el-form-item :label="$t('CargoMsg.Cargo_transferDeclareCompleted')">
              <!-- 中转地预计申报完成时间 -->
              <el-date-picker
                v-model="form.estDeclareCompletedTime"
                no="estDeclareCompletedTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 中转地实际申报完成时间 -->
              <el-date-picker
                v-model="form.declareCompletedTime"
                no="declareCompletedTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
            <!-- 中转地发运 -->
            <el-form-item :label="$t('CargoMsg.Cargo_transferShipping')">
              <!-- 中转地预计发运时间 -->
              <el-date-picker
                v-model="form.estShippingTime"
                no="estShippingTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 中转地实际发运时间 -->
              <el-date-picker
                v-model="form.actShippingTime"
                no="actShippingTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
            <!-- 到达目的地边境 -->
            <el-form-item :label="$t('CargoMsg.Cargo_arriveDestinationBorder')">
              <!-- 预计到达目的地边境时间 -->
              <el-date-picker
                v-model="form.estArrivePodTime"
                no="estArrivePodTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 实际到达目的地边境时间 -->
              <el-date-picker
                v-model="form.actArrivePodTime"
                no="actArrivePodTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
            <!-- 目的地清关信息-->
            <span class="title" style="margin-top: 10px; margin-bottom: 10px;">{{ $t('CargoMsg.Cargo_podClearInfo') }}</span>
            <!-- 到达目的地 -->
            <el-form-item :label="$t('CargoMsg.Cargo_arrivePod')">
              <!-- 预计到达目的地时间 -->
              <el-date-picker
                v-model="form.estEnterPodTime"
                no="estEnterPodTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 实际到达目的地时间 -->
              <el-date-picker
                v-model="form.actEnterPodTime"
                no="actEnterPodTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
            <!-- 到达清关地 -->
            <el-form-item :label="$t('CargoMsg.Cargo_arriveClear')">
              <!-- 预计到达清关地时间 -->
              <el-date-picker
                v-model="form.estArriveClearTime"
                no="estArriveClearTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 实际到达清关地时间 -->
              <el-date-picker
                v-model="form.actArriveClearTime"
                no="actArriveClearTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
            <!-- 卡航卸货 -->
            <el-form-item :label="$t('CargoMsg.Cargo_khUnloading')">
              <!-- 卡航预计卸货时间 -->
              <el-date-picker
                v-model="form.estDischargeTime"
                no="estDischargeTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
                @change="changeDischargeTime(false)"
              />
              <!-- 卡航实际卸货时间 -->
              <el-date-picker
                v-model="form.actDischargeTime"
                no="actDischargeTime"
                type="datetime"
                :disabled="hasMaster"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
                @change="changeDischargeTime(true)"
              />
            </el-form-item>
            <!-- 目的地派送信息-->
            <span class="title" style="margin-top: 10px; margin-bottom: 10px;">{{ $t('CargoMsg.Cargo_podDeliveryInfo') }}</span>
            <!-- 进仓交货 -->
            <el-form-item :label="$t('CargoMsg.Cargo_warehouseDelivery')">
              <!-- 预计进仓交货时间 -->
              <el-date-picker
                v-model="form.estWarehouseDeliveryTime"
                no="estWarehouseDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 实际进仓交货时间 -->
              <el-date-picker
                v-model="form.actWarehouseDeliveryTime"
                no="actWarehouseDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
            <!-- 送货 -->
            <el-form-item :label="$t('CargoMsg.Cargo_goodsDelivery')">
              <!-- 预计送货时间 -->
              <el-date-picker
                v-model="form.estGoodsDeliveryTime"
                no="estGoodsDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 实际送货时间 -->
              <el-date-picker
                v-model="form.actGoodsDeliveryTime"
                no="actGoodsDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
            <!-- 还空 -->
            <el-form-item :label="$t('CargoMsg.Cargo_podReturn')">
              <!-- 预计还空时间 -->
              <el-date-picker
                v-model="form.estReturnTime"
                no="estReturnTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%"
                :placeholder="$t('CargoMsg.Cargo_estTime')"
              />
              <!-- 实际还空时间 -->
              <el-date-picker
                v-model="form.actReturnTime"
                no="actReturnTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 49.5%; left: 2px"
                :placeholder="$t('CargoMsg.Cargo_actTime')"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form class="form-card" :disabled="readonly || hasMaster" label-width="130px" label-position="right" style="height:100%">
            <span class="title">{{ $t('SeaExport.SecondVesselInformation') }}</span>
            <el-form-item :label="$t('CargoMsg.Cargo_secondPlateNumber')">
              <el-input v-model="form.secondPlateNumber" no="secondPlateNumber" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_secondTrailerNumber')">
              <el-input v-model="form.secondTrailerNumber" no="secondTrailerNumber" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_secondVehicleType')">
              <cargo-advance-select
                :method-params="{typeKh:true}"
                no="secondVehicleType"
                :select-type="selectTypeNames.basic_data_VehicleModel"
                filterable
                :clearable="false"
                :show-custom-label-in-option="true"
                :custom-label="vehicleTypeLabel"
                :default-value="form.secondVehicleType"
                @parentCallBack="p=>{form.secondVehicleType=p.value;}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_secondEtd')">
              <el-date-picker v-model="form.secondEtd" no="secondEtd" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <!-- 起运地 -->
            <el-form-item :label="$t('CargoMsg.Cargo_secondPol')">
              <el-input v-model="form.secondPol" no="secondPol" />
            </el-form-item>
            <!-- 目的地 -->
            <el-form-item :label="$t('CargoMsg.Cargo_secondPod')">
              <el-input v-model="form.secondPod" no="secondPod" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_secondLoadingTime')">
              <el-date-picker v-model="form.secondLoadingTime" no="secondLoadingTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_secondShippingTime')">
              <el-date-picker v-model="form.secondShippingTime" no="secondShippingTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_secondArriveTime')">
              <el-date-picker v-model="form.secondArriveTime" no="secondArriveTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_secondDischargeTime')">
              <el-date-picker v-model="form.secondDischargeTime" no="secondDischargeTime" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_secondTransportType')">
              <el-input v-model="form.secondTransportType" no="secondTransportType" />
            </el-form-item>

            <span class="title" style="margin-top: 10px; margin-bottom: 10px;">{{ $t('CargoMsg.Cargo_bargeInfo') }}</span>
            <el-form-item :label="$t('CargoMsg.Cargo_bargeEtd')">
              <el-date-picker v-model="form.bargeEtd" no="bargeEtd" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_bargeAtd')">
              <el-date-picker v-model="form.bargeAtd" no="bargeAtd" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_bargePlateNumber')">
              <el-input v-model="form.bargePlateNumber" no="bargePlateNumber" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_bargeTrailerNumber')">
              <el-input v-model="form.bargeTrailerNumber" no="bargeTrailerNumber" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_bargePol')">
              <el-input v-model="form.bargePol" no="bargePol" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_bargePod')">
              <el-input v-model="form.bargePod" no="bargePod" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_bargeLine')">
              <el-input v-model="form.bargeLine" no="bargeLine" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_CYCutOffDate')">
              <el-date-picker v-model="form.bargeClosingDate" no="bargeClosingDate" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_bargeCarrierId')">
              <cargo-company-select
                no="bargeCarrierId"
                :method-params="{truckCmp:true,active:true,companyLob:'integratedJob'}"
                :default-value="form.bargeCarrierId||''"
                @change="p=>{form.bargeCarrierId=p.value;}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input
                v-model="form.bargeRemarks"
                no="bargeRemarks"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),form.bargeRemarks,val=>{form.bargeRemarks=val})"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="advanceTextDialog.value" :disabled="readonly" type="textarea" rows="10" />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TabOrderCarPM } from './tabOrderCarPM'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'TabOrderCar',
  components: {
    cargoCompanySelect, cargoAdvanceSelect
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabOrderCarPM(this),
      selectTypeNames: TYPE_NAMES,
      form: new IntegratedJob().fillDefaultValue().getData(),
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      }
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    config() {
      return this.context.config
    },
    hasMaster() {
      return !!this.form.lclMasterUuid
    }
  },
  watch: {
  },
  created() {
    this.visible = true
  },
  methods: {
    async onShow(row, isRefresh) {
      if (isRefresh) {
        this.form = row
        this.pm.changeJob()
        this.pm.fillView()
      }
    },
    async getSubmitData() {
      await this.validateForm()
      const job = { ...this.form }
      const res = { job }
      if (this.form.trucking) {
        res.truckingInfo = this.form.trucking
      }
      return res
    },
    validateForm() {
      const form = this.form
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    // 卡航换装时间同步
    async changeReplacementTime(isAct = false) {
      if (!(this.form.dischargingPortDoor && !this.form.multipleDischargingPickups)) return
      if (!this.form.truckingInfoPods || this.form.truckingInfoPods.length <= 0) return
      for (const truckingInfoPod of this.form.truckingInfoPods) {
        if (isAct) {
          truckingInfoPod.actLoadingDate = this.form.actReplacementTime
        } else {
          truckingInfoPod.loadingDate = this.form.estReplacementTime
        }
      }
    },
    // 卡航卸货时间同步
    async changeDischargeTime(isAct = false) {
      if (!(this.form.dischargingPortDoor && !this.form.multipleDischargingPickups)) return
      if (!this.form.truckingInfoPods || this.form.truckingInfoPods.length <= 0) return
      for (const truckingInfoPod of this.form.truckingInfoPods) {
        if (!truckingInfoPod.integratedTruckingInfo) continue
        if (isAct) {
          truckingInfoPod.integratedTruckingInfo.actualArrivalDate = this.form.actDischargeTime
        } else {
          truckingInfoPod.integratedTruckingInfo.arriveDate = this.form.estDischargeTime
        }
      }
    },
    // 拖车到货时间同步
    changeArriveTime(isAct = false) {
      if (!(this.form.landTransportation && !this.form.multiplePickups)) return
      if (!this.form.trucking || this.form.trucking.length <= 0) return
      for (const truckingInfo of this.form.trucking) {
        if (!truckingInfo.integratedTruckingInfo) continue
        if (isAct) {
          truckingInfo.integratedTruckingInfo.actualArrivalDate = this.form.actArriveTime
        } else {
          truckingInfo.integratedTruckingInfo.arriveDate = this.form.estArriveTime
        }
      }
    },
    // 拖车提货时间同步
    changeTakeTime(isAct = false) {
      if (!(this.form.landTransportation && !this.form.multiplePickups)) return
      if (!this.form.trucking || this.form.trucking.length <= 0) return
      for (const truckingInfo of this.form.trucking) {
        if (isAct) {
          truckingInfo.actLoadingDate = this.form.actTakeTime
        } else {
          truckingInfo.loadingDate = this.form.estTakeTime
        }
      }
    },
    vehicleTypeLabel(item) {
      return JobUtils.vehicleTypeLabel(item)
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      params.jobuuid = this.form.uuid
      params.JOB_UUID = this.form.uuid
      params.category = 'BOOKING'
      params.ctx = new IntegratedJob(this.form)
      return params
    }
  }
}
</script>

<style lang="scss">
  .tab-vessel-eq {
    /deep/ .el-submenu__title{
      border-bottom: none !important;
    }
    .warn-label .el-form-item__label{
      color: orange !important;
    }
  }
</style>
